import { render, staticRenderFns } from "./StandardProduzioneLayoutAdapter.vue?vue&type=template&id=517f9d74&scoped=true&"
import script from "./StandardProduzioneLayoutAdapter.vue?vue&type=script&lang=js&"
export * from "./StandardProduzioneLayoutAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f9d74",
  null
  
)

export default component.exports